import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import scrollbarWidth from '../../scripts/scrollbar-width'
import './modal.scss'
import './modal-search.scss'

const page = document.querySelector('body')
const header = document.querySelector('.header')
const scrollbar = scrollbarWidth()
const mobile = window.matchMedia('(max-width: 39.9375em)')

const createModal = () => {
  const modal = document.createElement('div')
  modal.classList.add('modal')
  modal.setAttribute('role', 'dialog')
  modal.setAttribute('aria-modal', 'true')
  document.body.appendChild(modal)
  const closeButton = document.createElement('button')
  const buttonDescription = document.createElement('span')
  buttonDescription.classList.add('show-for-sr')
  buttonDescription.textContent = 'Close search panel'
  closeButton.textContent = '×'
  closeButton.classList.add('modal__close')
  modal.appendChild(closeButton)
  closeButton.appendChild(buttonDescription)
  const modalContent = document.createElement('div')
  modalContent.classList.add('modal__content')
  modal.appendChild(modalContent)
  function close() {
    page.style.paddingRight = 0
    header.style.paddingRight = 0
    modal.classList.remove('modal_opened')
    enableBodyScroll(modal)
    setTimeout(() => {
      modalContent.innerHTML = ''
    }, 300)
  }
  closeButton.addEventListener('click', close)
  document.querySelectorAll('[data-modal-wrapper]').forEach(wrapper => {
    const toggle = wrapper.querySelector('[data-modal-toggle]')
    const content = wrapper.querySelector('[data-modal-content]')
    if (wrapper.dataset.modalWrapper === 'mobile-only' && !mobile) {
      return
    }
    function open() {
      page.style.paddingRight = `${scrollbar}px`
      header.style.paddingRight = `${scrollbar}px`
      modalContent.innerHTML = content.innerHTML
      modal.classList.add('modal_opened')
      if (wrapper.dataset.modalWrapper === 'search') {
        modal.classList.add('modal--search')
      }
      disableBodyScroll(modal)
      document.body.style.marginRight = ''
    }
    toggle.addEventListener('click', () => {
      open()
    })
    toggle.addEventListener('keydown', e => {
      if (e.keyCode === 13 || e.keyCode === 32) {
        open()
      }
    })
  })
  window.addEventListener('keydown', e => {
    if (e.keyCode === 27) {
      close()
    }
  })
}

export default container => {
  createModal(container)
}
